import VueRouter from 'vue-router/'
import router from "../core/vue-router/vue-router-basic";
import SSRComponent from '../components/SSRComponent';
import VueTippy, {TippyComponent} from "vue-tippy";
import registerSentry from "@/core/utils/helpers/registerSentry";

utils.registerGlobalComponents(Vue);

/**
 * Local component registration
 */
Vue.component('sidebar-component', require('../components/views/theme/default/partials/SidebarComponent').default);
Vue.component('search-component', require('../components/search/SearchComponent.vue').default);
Vue.component('home-search-component', require('../components/search/HomeSearchComponent.vue').default);
Vue.component('mobile-search-component', require('../components/search/MobileSearchComponent.vue').default);
Vue.component('main-search-component', require('../components/search/MainSearchComponent').default);
Vue.component('cms-routing-component', require('../components/seo/CmsRoutingComponent').default);
Vue.component('home-component', require('../components/HomeComponent').default);
Vue.component('users-profile-component', require('../components/users/profile/UsersProfileComponent').default);
Vue.component('search-filter-services-component', require('../components/search/partials/filters/SearchFilterServicesComponent').default);
Vue.component('search-filter-location-component', require('../components/search/partials/filters/SearchFilterLocationComponent').default);
Vue.component('search-filter-price-component', require('../components/search/partials/filters/SearchFilterPriceComponent').default);
Vue.component('search-filter-features-component', require('../components/search/partials/filters/SearchFilterFeaturesComponent').default);
Vue.component('search-filter-category-component', require('../components/search/partials/filters/SearchFilterCategoryComponent').default);
Vue.component('search-filter-extra-content-component', require('../components/search/partials/filters/SearchFilterExtraContentComponent.vue').default);
Vue.component('search-filter-flairs-component', require('../components/partials/SearchFilterFlairsComponent').default);
Vue.component('search-filter-flairs-scoped-component', require('../components/partials/SearchFilterFlairsScopedComponent').default);
Vue.component('search-breadcrumbs-component', require('../components/search/partials/SearchBreadcrumbsComponent').default);
Vue.component('pagination-component', require('../components/partials/PaginationComponent').default);
Vue.component('search-no-js-placeholder-component', require('../components/search/partials/SearchNoJSPlaceholderComponent').default);
Vue.component('why-advertise-component', require('../components/public/WhyAdvertiseComponent').default);
Vue.component('suggest-region-redirect-component', require('../components/partials/SuggestRegionRedirectComponent.vue').default);

Vue.use(VueRouter);
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

if (process.env.MIX_VUE_DEV_TOOLS) {
    Vue.config.devtools = true;
}

registerSentry(router);

const app = new Vue({
    store: $store,
    router,
    methods: {
        checkAuth: async () => {
            if (typeof isUserLoggedIn != 'undefined' && isUserLoggedIn) {
                $store.commit('setCurrentUser', user);
            }
        },
        addPopstateHandler() {
            window.addEventListener('popstate', this.popstateEventListener);
        },
        removePopstateHandler() {
            window.removeEventListener('popstate', this.popstateEventListener);
        },
        popstateEventListener() {
            // Used to close select 2 on back button
            if (window.isLocationModalActive) {
                $('select').each(function (index, obj) {
                    if ($(obj).data('select2')) {
                        $(obj).select2('close');
                    }
                });
            }

            // Used to close filter modal on back button
            if (window.isFilterModalActive) {
                $('#close-filter-search').trigger('close');
                $store.commit('setFilterOpened', false);
            }

            window.isLocationModalActive = false;
            window.isFilterModalActive = false;
        }
    },
    mounted() {
        this.addPopstateHandler();
    },
    destroyed() {
        this.removePopstateHandler();
    },
    render: h => h(SSRComponent),
});

app.checkAuth();

export default app;
